import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react'
import { useDeletePaymentGateway } from 'queries/paymentGateway.query'

export function DeleteGatewayModal({ isOpen, onClose, gateway }) {
  const toast = useToast()
  const deleteMutation = useDeletePaymentGateway()

  const handleDelete = async () => {
    if (!gateway) return
    try {
      await deleteMutation.mutateAsync(gateway.id)
      toast({
        title: 'Payment Gateway Deleted',
        description: `Gateway "${gateway.name}" was removed.`,
        status: 'success',
        duration: 3000,
      })
      onClose()
    } catch (err) {
      toast({
        title: 'Delete Failed',
        description: err.response?.data?.message || 'Could not delete payment gateway.',
        status: 'error',
        duration: 4000,
      })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent borderRadius="20px">
        <ModalHeader fontWeight="bold">Delete Payment Gateway</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete payment gateway{' '}
            <Text as="span" fontWeight="bold" color="red.500">
              "{gateway?.name}"
            </Text>
            ?
          </Text>
          <Text fontSize="sm" color="gray.500" mt={2}>
            If this gateway has recorded orders, it cannot be deleted and should be deactivated instead.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} borderRadius="10px">
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={handleDelete}
            isLoading={deleteMutation.isLoading}
            borderRadius="10px"
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
